<template>
  <div>
    <Input v-model="selfSelectedRowTitle" :disabled="disabled" :placeholder="'Search ' + title " @on-focus="showSearchModal = true"></Input>
    <Modal v-model="showSearchModal"
      :title="title"
      :width="width"
      footer-hide
      scrollable
      closable
      >
      <Input search enter-button :placeholder="'Search ' + title " v-model="keyword" @on-search="handleSearch"/>
      <vxe-grid
          border='inner'
          resizable
          stripe
          showOverflow
          :data="tableData"
          :loading="loading"
          :columns="columns"
          ref="searchResult"
          column-min-width="50"
          size="mini"
          row-id="id"
          max-height="600px"
          :radio-config="{trigger: 'row', checkRowKey: selfSelectedRowId}"
          @radio-change="handleCheckon"
          >
        </vxe-grid>
    </Modal>
  </div>
</template>

<script>
import Vue from 'vue'
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/index.css'
Vue.use(VXETable)

export default {
  name: 'PopupSelectWidget',
  props: {
    title: {
      type: String,
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
    action: {
      type: Function,
      required: true
    },
    selectedRowId: {
      type: [Number, String],
      default: null
    },
    selectedRowTitle: {
      type: String
    },
    width: {
      type: Number,
      default: 800
    },
    defaultData: {
      type: Array,
      default: () => {
        return []
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    selectedRowTitle (newVal) {
      this.selfSelectedRowTitle = newVal
    },
    defaultData: {
      handler(newVal) {
        this.tableData = newVal
      },
      deep: true
    },
    selectedRowId (newVal) {
      this.selfSelectedRowId = newVal
    }
  },
  data() {
    return {
      loading: false,
      tableData: this.defaultData,
      keyword: null,
      showSearchModal: false,
      selfSelectedRowTitle: this.selectedRowTitle,
      selfSelectedRowId: this.selectedRowId
    }
  },
  methods: {
    async handleSearch (keyword) {
      this.loading = true
      this.tableData = await this.action(keyword)
      this.loading = false
    },
    setTableData(data) {
      this.tableData = data
    },
    handleCheckon({ row, rowIndex, $rowIndex, column, columnIndex, $columnIndex, $event }) {
      this.$emit('on-select', row)
      // this.showSearchModal = false
    }
  }
}
</script>

<style lang="less" scoped>

</style>
